

























import { Vue, Component, Prop } from 'vue-property-decorator';
import EventLabel from './EventLabel.vue';
import { EventAndNewsService } from '../../../biz/remote/EventAndNewsService';
import { D_FORMAT_JA, dayjs } from '../../../../src_server/common/momentExtends';
import NewsLabel from './NewsLabel.vue';
import { NewsEventNotice } from '../../../../src_server/entity/generated/NewsEventNotice';
import { LocalData } from '../../../utils/LocalData';
@Component({
  components: { EventLabel, NewsLabel },
  filters: {
    dateFormat(dt: Date) {
      return dayjs(dt).format(D_FORMAT_JA);
    },
    trim(title: string) {
      if (title.length < 30) {
        return title;
      } else {
        return `${title.substring(1, 30)}...`;
      }
    },
  },
})
export default class NewsAndEventSection extends Vue {
  @Prop({ default: 'news' })
  private type!: 'news' | 'event';
  private data: NewsEventNotice[] = [];

  private notReadCount = 0;

  updateReadCount() {
    const ids = LocalData.getShownNewsAndEvent();
    this.notReadCount = this.data.reduce((a, c) => {
      return c.notice_id && !ids.includes(c.notice_id) ? a + 1 : a;
    }, 0);
  }

  private get model() {
    return this.data.slice(0, 2);
  }

  more() {
    this.notReadCount = 0;
    this.$emit('more', this.type, this.data);
  }

  async created() {
    const eventAndNews = new EventAndNewsService();
    let response;
    if (this.type === 'event') {
      response = await eventAndNews.getEvents();
    } else {
      response = await eventAndNews.getNews();
    }
    this.data = response.data.sort((a, b) => {
      return dayjs(b.notice_start_dt).diff(dayjs(a.notice_start_dt));
    });

    // カウント
    this.updateReadCount();
  }
}
